import '../mainPage.css';
import React from 'react';
import GitHubLogo from '../GitHub-logo-green.png';

const footer_links = [
  {
    name:'Portfolio',
    link: 'https://yoseline-guerrero.netlify.app/'
  }, {
    name:'Code for this Site',
    link: 'https://github.com/YoselineGuerrero/react-api-pratice'
  }, {
    name:'GitHub Profile',
    link: 'https://github.com/YoselineGuerrero'
  }, {
    name:'LinkedIn',
    link: 'https://www.linkedin.com/in/yoseline-guerrero/'
  },
]

export default function Footer(){
  const currentYear = new Date().getFullYear();
  return(
    <div id = 'footer'>
      <p style={{marginTop:'24px', fontSize:'12px'}} className='subtitle'> Found a bug? Create a <a id='issue-links'  className='a-link footer-links' href='https://github.com/YoselineGuerrero/react-api-pratice/issues' target='_blank' rel="noreferrer">issue </a>or <a className='a-link footer-links' id='email-links' href='mailto:yguerrerocs@gmail.com?subject=Bug%20Found%20in%20GitHub%20Project' target='_blank' rel="noreferrer">contact me.</a></p>
      <hr style={{marginTop:'40px', width:'90%'}}/>
      <div id='footer-menu'>
        <div id='footer-img'>
          <img src={GitHubLogo} width="35px"  alt=''></img>
          <span id='footer-title'>© {currentYear} Yoseline Guerrero</span>
        </div>
        <div id='footer-a'>
          {footer_links.map((link) => (
            <a id={link.name} key={link.name} href={link.link} target='_blank' rel="noreferrer" className='footer-links'>{link.name}</a>
          ))}
        </div>
        <div id='footer-img-small'>
          <img src={GitHubLogo} width="35px"  alt=''></img>
          <span id='footer-title'>© {currentYear} Yoseline Guerrero</span>
        </div>
      </div>
    </div>
  );
}
